import ApiService from "./ApiService";

class CompanyService extends ApiService{
    constructor() {
        super();
        this._generalDataUrl = '/company/get-general-data';
        this._saveDataUrl = '/company/save-data';
        this._saveImageUrl = '/company/save-logo';
        this._deleteLogoUrl = '/company/delete-logo';
    }

    getGeneralData() {
        return this.postResource(this._generalDataUrl, {}, this.getBaseHeaders());
    }
    saveData(data) {
        return this.postResource(this._saveDataUrl, data, this.getBaseHeaders());
    }
    saveImage(data) {
        const headers = {...this.getBaseHeaders(), 'Content-Type': 'multipart/form-data'};
        return this.postResource(this._saveImageUrl, data, headers);
    }
    deleteLogo(data) {
        // const headers = {...this.getBaseHeaders(), 'Content-Type': 'multipart/form-data'};
        return this.postResource(this._deleteLogoUrl, data, this.getBaseHeaders());
    }
    getCompany(id) {
        return this.postResource(this._getCompany + id, {}, this.getBaseHeaders());
    }
    getCompanyRate(id) {
        const params = {companyId: id};

        return this.postResource(this._getCompanyRate, params, this.getBaseHeaders());
    }
    setCompanyRate(params) {

        return this.postResource(this._setCompanyRate, params, this.getBaseHeaders());
    }
    getCompanyFeedback(id) {
        const params = {companyId: id};

        return this.postResource(this._getCompanyFeedbacks, params, this.getBaseHeaders());
    }
    getCompanies() {
        return this.postResource(this._getCompanies, {}, this.getBaseHeaders());
    }
    createCompanyFeedback(params) {

        return this.postResource(this._createCompanyFeedback, params, this._authService.getAuthHeader());
    }
    getUser() {
        return this.postResource(this._authMe,  this.getBaseHeaders());
    }
}

const companyService = new CompanyService();

export default companyService;
